/**
 * @title member-verification.js: Sub-module of Account feature
 * @description This module provides membership verification functionality.
 * @dependency utility.js, costcodialog.js
 */
define([], function() {
  let MemberVerification = {

	init: function() {
      this.validationRules();
      this.maskDateInput();
    },

    membershipNumber: null,

    getForm: function() {
      return $('#MemberVerificationForm');
    },

    validateNumberForm: function() {
      MemberVerification.getForm().validate({
        rules: {
          membershipNumberToVerify: {
            required: true,
            membershipNumber: true,
          },
        },
        messages: {
          membershipNumberToVerify: {
            required: messages.ERR_INVALID_MEMBERSHIP_NO,
            membershipNumber: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
        },
        invalidHandler: function(event, validator) {
        	var errors = validator.numberOfInvalids();
        	if (errors) {
        		window.digitalDataEvents = window.digitalDataEvents || [];
        		digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter Valid Membership Number Error" } )
        	}
        }
      });

      return MemberVerification.getForm().valid();
    },

    maskDateInput: function() {
      $('#employeeStartDate').mask('00/00', {
        placeholder: 'MM/YY',
      });
    },
    
    validateZipCodeForm: function(form = COSTCO.MemberVerification.getForm()) {
      form.validate({
        rules: {
          questionLastName: {
            required: true
          },
          questionZip: {
            'required': true,
            'postalcode': true
          },
        },
        messages: {
          questionLastName: messages.ERR_INVALID_LASTNAME,
          questionZip: messages.ERR_ENTER_ZIPCODE
        },
        invalidHandler: function(event, validator) {
        	var errors = validator.numberOfInvalids();
        	if (errors) {
        		for(let i = 0; i < errors; i++) {
        			COSTCO.MemberVerification.fireAnalyticsEventLastNameOrZipCodeError(validator.errorList[i].element);
        		}
        	}
        }
      });

      return form.valid();
    },

    fireAnalyticsEventLastNameOrZipCodeError: function(element) {
		const test = $(element).is("input[name='questionLastName']")
		if(test) {
			digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter Your Last Name Error" } )
		} else {
			digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter a Valid Zip Code Error" } )
		}
    },
    
    validationRules: function() {
      $.validator.addMethod('membershipNumber', function(value, element) {
        // costco pins are 12 digits
        return this.optional(element) || /^\d{12,16}$/.test(value);
      }, messages.MEMBERVERIFICATION_MEMBERSHIP__InvalidMembershipNumber);

      $.validator.addMethod('postalcode', function(value, element) {
        return this.optional(element) || /^(\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1})$/.test($.trim(value));
      }, messages.ERR_ENTER_ZIPCODE);
    },
    /**
     * Submits request for membership verification steps
     * @param  {String} urlWithParams Service URL with query string parameters appended
     * @return {jQuery.Deferred}      The deferred object
     */
    submitRequest: function(urlWithParams) {
      return COSTCO.util.ajax({
          type: 'POST',
          url: urlWithParams,
          dataType: 'json',
        })
        // This returns a chainable promise.
        .then((data) => {
          if (data && data.CRM_ERROR_FRAMEWORK) {
            let errorTmpl = (isDmcPage) ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error';
            let errorTmplData = {
              membershipNumber: MemberVerification.membershipNumber,
            };

            switch (data.CRM_ERROR_FRAMEWORK) {

              case 'ERROR_EXCEEDED_MAX_AUTH_ATTEMPTS':
            	if (isDmcPage) {
            		errorTmpl = 'tmpl_membership_dmc_verify_err_max_retries_reached';
            	} else {
            		errorTmpl = 'tmpl_membership_verify_err_max_retries_reached';
            	}
                break;

              case 'ERROR_ONLINE_VERIFY_US':
            	  errorTmpl = 'tmpl_membership_verify_err_service_error_us';
            	  break;
            	  
              case 'ERROR_PRESCREEN_ATTEMPT_FAILED':
                switch (data.CRM_MEMBER_TYPE) {
                  case 'E':
                    errorTmpl = 'tmpl_membership_verify_err_employee_membership';
                    break;

                  case 'T':
                    errorTmpl = 'tmpl_membership_verify_err_trial_membership';
                    break;

                  case 'X':
                    errorTmpl = 'tmpl_membership_verify_err_inactive_membership';
                    break;

                  default:
                    errorTmpl = 'tmpl_membership_verify_err_try_again';
                }
                
            }
            
            MemberVerification.doAnalytics(errorTmpl);
            
            return $.Deferred().reject(errorTmpl, errorTmplData);
          }

          return $.Deferred().resolve(data);
        })
        .fail((errorTmpl, errorTmplData) => {
          if (errorTmpl) {
            MemberVerification.displayErrorInModal(errorTmpl, errorTmplData);
          }
        });
    },
    
    doAnalytics: function(errorTmpl) {
    	window.digitalDataEvents = window.digitalDataEvents || [];
    	switch (errorTmpl) {
    		case 'tmpl_membership_verify_err_service_error': 
    			digitalDataEvents.push( { ui:"Member Verification Flow | Not Able to Verify Error" } );
    			break;
    		case 'tmpl_membership_verify_err_try_again': 
    			digitalDataEvents.push( { ui:"My Account | Membership | Verify Membership | No Match" } );
    			break;
    		case 'tmpl_membership_verify_err_max_retries_reached': 
    			digitalDataEvents.push( { uimsg:"Member Verification Flow | Exceeded Number of Attempts Error" } );
    			break;
    		case 'tmpl_membership_verify_err_service_error_us':
    			digitalDataEvents.push( { uimsg:"My Account | Membership | Verify Membership | Unsuccessful" } );
    			break;
    	}
    },
    /**
     * Invalidates session on backend for membership verification process
     */
    invalidateSession: function() {
      let url = MemberVerification.makeVerificationUrl({
        membershipNumber: MemberVerification.membershipNumber,
        invalidSession: true,
      });

      MemberVerification.submitRequest(url);
    },
    /**
     * Makes URL with string params for membership account verification services
     * @param  {Object} params  JSON obj with params to be put in URL as a query string e.g. {membershipNumber: 4444333322221111, invalidSession: true}
     * @return {String}         URL for membership account verification services with query string paramaters
     *                          e.g. /AjaxMembershipAccountVerificationCmd?membershipNumber=4444333322221111&invalidSession=true
     */
    makeVerificationUrl: function(params) {
      return COSTCO.util.makeUrl('/AjaxMembershipAccountVerificationCmd', params);
    },
    /**
     * Opens membership verification dialog
     * @param  {number} membershipNum Membership number
     */
    openMembershipVerificationDialog: function(membershipNum) {
      MemberVerification.membershipNumber = membershipNum;
      
      window.digitalDataEvents = window.digitalDataEvents || [];
      digitalDataEvents.push( { uimsg:"navName:DMC | Verify Your Membership | Verify Now" } );
      
      let doNotCloseModalFlag = false;
      isDmcPage = typeof isDmcPage !== "undefined" && isDmcPage === "true";
      if(isDmcPage){
    	  doNotCloseModalFlag = true;
    	  $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-sm-12 col-md-12 col-lg-12');
      }
      
      let settings = {
        dialogclasses: 'verify-membership-dialog',
        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
        body: COSTCO.util.tmpl('tmpl_membership_verify_number', {
          membershipNumber: MemberVerification.membershipNumber,
        }),
        footerText: isDmcPage ? COSTCO.util.tmpl('tmpl_membership_verify_buy_membership') : '',
        preventClose: doNotCloseModalFlag,
        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
        secondary: !isDmcPage ? messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText : '',        	
        primary_event: () => {
                  	
          if (MemberVerification.validateNumberForm()) {
            MemberVerification.membershipNumber = parseInt($('#membershipNumberToVerify').val());

            let url = MemberVerification.makeVerificationUrl({
              membershipNumber: MemberVerification.membershipNumber,
            });

            MemberVerification.submitRequest(url)
              .then((data) => {
            	if(isDmcPage) {
                  $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-md-6');
                }
                if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
                  MemberVerification.showQuestionsStep(data);
                } else {
                  MemberVerification.showPrescreen(data);
                }
              });
          } else {
        	  window.digitalDataEvents = window.digitalDataEvents || [];
        	  digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter Valid Membership Number Error" } )
          }
        },
        secondary_event: () => {
        	if(isDmcPage) {
        		MemberVerification.proceedeToDMCCheck('verification', false);
		    } else {
		    	COSTCO.dialog.close();
		    }
        },
        close: () => {
        	if(isDmcPage) {
        		MemberVerification.proceedeToDMCCheck('verification', false);
		    } else {
		    	COSTCO.dialog.close();
		    }
        },
        onshown: () => {
          COSTCO.util.maskMembershipInput();
        },
      };

      COSTCO.dialog.createExtDialogBox(settings);
    },
    /**
     * Shows prescreen (last name / zip code form)
     * @param  {Object} data Data response returned from server
     */
    showPrescreen: function(data) {
      COSTCO.dialog.updateModal({
        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
        body: COSTCO.util.tmpl('tmpl_membership_verify_prescreen', {}),
        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
        primary_event: () => {
          if (MemberVerification.validateZipCodeForm()) {
            let url = MemberVerification.makeVerificationUrl({
              lastName: $('#questionLastName').val(),
              zipCode: $('#questionZip').val(),
            });

            MemberVerification.submitRequest(url)
              .then(MemberVerification.showQuestionsStep);
          }
        },
        secondary_event: () => {
        	if(isDmcPage) {
	      	  	MemberVerification.proceedeToDMCCheck('verification', false);
	        } else {
	        	COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	        }
        },
        close: () => {
        	if(isDmcPage) {
	      	  	MemberVerification.proceedeToDMCCheck('verification', false);
	        } else {
	        	COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	        }
        },
        onshown: () => {
          COSTCO.util.maskMembershipInput();
        },
      });
    },

    /**
     * Updates modal with questions to select. If there is another question returned from backend, call it self again to display new question.
     * @param  {Object} data Response data from previous step
     */
    showQuestionsStep: function(data) {
      let questionsBodyTmpl = '';

      if (data.CRM_AUTH_QUESTION) {
        questionsBodyTmpl = $(COSTCO.util.tmpl('tmpl_membership_verify_questions', {
          membershipNumber: MemberVerification.membershipNumber,
          verificationQuestion: data.CRM_AUTH_QUESTION.question,
        }));

        let questionsTmpl = questionsBodyTmpl.find('#verification-questions');

        if (questionsTmpl.length) {
          $.each(data.CRM_AUTH_QUESTION.answers, (index, value) => {
            questionsTmpl.append(
              COSTCO.util.tmpl('tmpl_membership_verify_question_item', {
                answerId: index,
                verificationAnswer: value,
              })
            );
          });
        }
      }

      COSTCO.dialog.updateModal({
        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
        body: questionsBodyTmpl,
        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
        primary_event: () => {
          let selectedAnswer = $('input[name=CRManswer]:checked').val();

          let url = MemberVerification.makeVerificationUrl({
            answerNumber: selectedAnswer,
          });


          let loadingTmpl = 'tmpl_membership_questions_loading';
          if (data.CRM_AUTH_LAST_STEP) {
            loadingTmpl = 'tmpl_membership_verify_loading';
          }

          COSTCO.dialog.updateModal({
            title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
            body: COSTCO.util.tmpl(loadingTmpl, {}),
            onshown: () => {
              COSTCO.util.maskMembershipInput();
            },
          });

          MemberVerification.submitRequest(url)
            .then((data) => {
              if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
                MemberVerification.showQuestionsStep(data);
              } else if (data.CRM_AUTH_PASSED == true) {
                MemberVerification.showSuccessStep();
              } else {
                MemberVerification.displayErrorInModal((isDmcPage) ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error');
              }
            });
        },
        secondary_event: () => {
        	if(isDmcPage) {
	      	  	MemberVerification.proceedeToDMCCheck('verification', false);
	        } else {
	        	COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	        }
        },
        close: () => {
        	if(isDmcPage) {
	      	  	MemberVerification.proceedeToDMCCheck('verification', false);
	        } else {
	        	COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	        }
        },
        onshown: () => {
          COSTCO.util.maskMembershipInput();
        },
      });
    },
    /**
     * Transfer request to DMC handler
     */
    proceedeToDMCCheck: function(action, actionSuccessful) {
    	
    	COSTCO.dialog.close();
    	let command = "/DMCCheck";
    	
    	let queryStart = "?";
    	let queryConcat = "&";
    	let queryAction = "action=" + action;
    	let queryDeviceId = "deviceId=" + deviceId;
    	let queryVerified = "verified=" + actionSuccessful;    	
    	let queryRenewalCanceled = "renewCanceled=" + actionSuccessful;
    	let queryString = queryStart + queryAction + queryConcat + queryDeviceId + queryConcat;
    	
    	if(action == 'renewal')
    		queryString += queryRenewalCanceled;
    	else
    		queryString += queryVerified;
    	
    	let newURL = window.location.protocol + "//" + window.location.host + command + queryString;
    	window.location.replace(newURL);
    },
    /**
     * Update modal with succcess text
     */
    showSuccessStep: function() {
      window.digitalDataEvents = window.digitalDataEvents || [];
      digitalDataEvents.push( { uimsg:"My Account | Membership | Verify Membership | Success" } )
      COSTCO.dialog.updateModal({
        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
        body: COSTCO.util.tmpl('tmpl_membership_verify_success', {}),
        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
        primary_event: () => {          
			if(isDmcPage) {
				MemberVerification.proceedeToDMCCheck('verification', true);
			} else {
				COSTCO.dialog.close();
				location.reload();
			}
  
        },
        close: () => {
	    	if(isDmcPage) {
	      	  	MemberVerification.proceedeToDMCCheck('verification', true);
	        } else {
		      	COSTCO.dialog.close();
		      	location.reload();
	        }
        },
        onshown: () => {
          COSTCO.util.maskMembershipInput();
        },
      });
    },
    /**
     * Update modal with error text from prepared template.
     * @param  {string} errorTemplate   Template id
     * @param  {Object} data            Data used to populate in template
     */
    displayErrorInModal: function(errorTemplate, data) {
      COSTCO.dialog.updateModal({
        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
        body: COSTCO.util.tmpl(errorTemplate, data),
        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
        primary_event: () => {
	      	COSTCO.dialog.close();
	      	location.reload();
        },
        close: () => {
        	if(isDmcPage) {
	      	  	MemberVerification.proceedeToDMCCheck('verification', false);
	        } else {
		      	COSTCO.dialog.close();
		      	location.reload();
	        }
        },
        onshown: () => {
          COSTCO.util.maskMembershipInput();
        },
      });
    },


  };
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.MemberVerification = MemberVerification;
  return MemberVerification;
});



// WEBPACK FOOTER //
// ./js/account/member-verification.js